import type { FC, ReactNode, RefObject } from "react";
import type { Placement } from "react-aria";
import { Tooltip } from "react-aria-components";
import { TooltipArrow } from "./arrow.js";
import { tooltipOffsetForArrow, tooltipStyle } from "./style.js";

export interface SimpleTooltipProps {
  triggerRef?: RefObject<Element | null>;
  placement?: Placement;
  children?: ReactNode;
}

/** Basic tooltip for use in `TooltipTrigger`. */
export const SimpleTooltip: FC<SimpleTooltipProps> = (props) => {
  return (
    <Tooltip
      className={tooltipStyle().tooltip()}
      triggerRef={props.triggerRef}
      placement={props.placement}
      offset={tooltipOffsetForArrow}
    >
      <TooltipArrow />
      <div className={tooltipStyle().content()}>{props.children}</div>
    </Tooltip>
  );
};
